import React from 'react';

import styled from 'styled-components';
import { RibbonTab } from '../widgets';

import { AdvancedSearchComponent } from '../../../auto/js/widgets/AdvancedSearchComponent';
import CreateOrSearchComponentClass from '../widgets/CreateOrSearchComponentClass';
import { createBrowserComponent } from './Browser';

const Main = styled.main`
    position: relative;
    overflow: hidden;
    transition: all .15s;
    height: calc(100vh - 278px);
	overflow-y: auto;
	direction: ltr;
	margin-top: 20px;
	margin-bottom: 20px;
`;
export class RibbonBrowser extends createBrowserComponent() {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }
    
    render() {
        
        return (
            <>
			<RibbonTab menuSection={this.props.menuSection} gui={this}/>
			<Main>
			{this.buildDesktop()}
			</Main>
			<AdvancedSearchComponent/>
            <CreateOrSearchComponentClass />
            </>
        )
    }
}